import React, { FC, useContext, useEffect, useMemo, useState } from "react";
import facebookSvg from "images/Facebook.svg";
import twitterSvg from "images/Twitter.svg";
import googleSvg from "images/Google.svg";
import { Helmet } from "react-helmet";
import Input from "shared/Input/Input";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

import { PhoneInput } from 'react-international-phone';
//import 'react-international-phone/style.css';
import { requestAPI } from "utils/api";
import { UIContext } from "contexts/UIContext";
import { GlobalDataContext } from "contexts/GlobalData";


  
  




const FloattingButtons = ({ 
	bottom = false
}: any) => {
	
	// const {
	// 	toast,
	// 	modal,
	// } = useContext(UIContext);  
	// const { 
	// 	initData
	// } = useContext (GlobalDataContext);

	const navigate = useNavigate ();
	const location = useLocation();


	

	

	const [kakaoLink, setKakaoLink] = useState('');

	useEffect(()=>{
		(async () => {
			const res: any = await requestAPI('GET', 'v1/site-config', null);
			if (res.code === 1000 && res.data.config?.kakaoLink) {
				setKakaoLink(res.data.config.kakaoLink);
			}
		})();
	},[])

	

	

	return (
		<>
			<>
			{bottom && (
				<div className={`fixed bottom-[65px] right-4 flex flex-col gap-2 items-end z-50`}>
					{kakaoLink && (
					<a
						href={kakaoLink}
						target="_blank"
						rel="noopener noreferrer"
						className="p-3 rounded-full bg-[#FEE500] text-[#3C1E1E] shadow-lg hover:bg-[#FEE500] transition-all duration-300 ease-in-out w-12 flex items-center justify-center hover:w-[150px] group"
					>
						<svg className="w-6 h-6 group-hover:mr-2" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
							<path d="M12 3C6.477 3 2 6.463 2 10.691c0 2.734 1.811 5.134 4.537 6.505-.2.744-.725 2.695-.83 3.115-.13.524.192.517.403.376.166-.11 2.638-1.796 3.71-2.525.706.1 1.434.153 2.18.153 5.523 0 10-3.463 10-7.624C22 6.463 17.523 3 12 3z"/>
						</svg>
						<span className="hidden group-hover:inline whitespace-nowrap">카카오톡 문의</span>
					</a>
					)}
					<a
						href="mailto:hello@alltacompany.co.kr"
						target="_blank"
						rel="noopener noreferrer"
						className="p-3 rounded-full bg-[#991b1b] text-white shadow-lg hover:bg-[#991b1b] transition-all duration-300 ease-in-out w-12 flex items-center justify-center hover:w-[150px] group"
					>
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
							<path strokeLinecap="round" strokeLinejoin="round" d="M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H6.911a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661Z" />
						</svg>

						<span className="hidden group-hover:inline whitespace-nowrap">단체문의</span>
					</a>
					<a
						href="https://www.youtube.com/@allta_jayson"
						target="_blank"
						rel="noopener noreferrer"
						className="p-3 rounded-full bg-[#991b1b] text-white shadow-lg hover:bg-[#991b1b] transition-all duration-300 ease-in-out w-12 flex items-center justify-center hover:w-[150px] group"
					>
						<svg
							className="w-6 h-6 group-hover:mr-2"
							fill="currentColor"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
						</svg>
						<span className="hidden group-hover:inline whitespace-nowrap">YouTube</span>
					</a>
					
					<a
						href="tel:070-8057-6837"
						className="p-3 rounded-full bg-[#991b1b] text-white shadow-lg hover:bg-[#991b1b] transition-all duration-300 ease-in-out w-12 flex items-center justify-center hover:w-[150px] group"
					>
						<svg
							className="w-6 h-6 group-hover:mr-2"
							fill="currentColor"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
						</svg>
						<span className="hidden group-hover:inline whitespace-nowrap">070-8057-6837</span>
					</a>

					<button
						onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
						className="p-3 rounded-full bg-[#991b1b] text-white shadow-lg hover:bg-[#991b1b] transition-all duration-300 ease-in-out w-12 flex items-center justify-center hover:w-[150px] group"
					>
						<svg
							className="w-6 h-6 group-hover:mr-2"
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M5 10l7-7m0 0l7 7m-7-7v18"
							/>
						</svg>
						<span className="hidden group-hover:inline whitespace-nowrap">맨 위로 이동</span>
					</button>
				</div>
			)}
			</>
			<>
			{bottom === false && (
				<div className={`fixed bottom-[65px] right-4 flex flex-col gap-2 items-end z-50`}>
					{kakaoLink && (
					<a
						href={kakaoLink}
						target="_blank"
						rel="noopener noreferrer"
						className="p-3 rounded-full bg-[#FEE500] text-[#3C1E1E] shadow-lg hover:bg-[#FEE500] transition-all duration-300 ease-in-out w-12 flex items-center justify-center hover:w-[150px] group"
					>
						<svg className="w-6 h-6 group-hover:mr-2" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
							<path d="M12 3C6.477 3 2 6.463 2 10.691c0 2.734 1.811 5.134 4.537 6.505-.2.744-.725 2.695-.83 3.115-.13.524.192.517.403.376.166-.11 2.638-1.796 3.71-2.525.706.1 1.434.153 2.18.153 5.523 0 10-3.463 10-7.624C22 6.463 17.523 3 12 3z"/>
						</svg>
						<span className="hidden group-hover:inline whitespace-nowrap">카카오톡 문의</span>
					</a>
					)}
					<a
						href="mailto:hello@alltacompany.co.kr"
						target="_blank"
						rel="noopener noreferrer"
						className="p-3 rounded-full bg-[#991b1b] text-white shadow-lg hover:bg-[#991b1b] transition-all duration-300 ease-in-out w-12 flex items-center justify-center hover:w-[150px] group"
					>
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
							<path strokeLinecap="round" strokeLinejoin="round" d="M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H6.911a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661Z" />
						</svg>

						<span className="hidden group-hover:inline whitespace-nowrap">단체문의</span>
					</a>
					<a
						href="https://www.youtube.com/@allta_jayson"
						target="_blank"
						rel="noopener noreferrer"
						className="p-3 rounded-full bg-[#FF0000] text-white shadow-lg hover:bg-[#FF0000] transition-all duration-300 ease-in-out w-12 flex items-center justify-center hover:w-[150px] group"
					>
						<svg
							className="w-6 h-6 group-hover:mr-2"
							fill="currentColor"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
						</svg>
						<span className="hidden group-hover:inline whitespace-nowrap">YouTube</span>
					</a>
					
				<a
						href="tel:070-8057-6837"
						className="p-3 rounded-full bg-[#991b1b] text-white shadow-lg hover:bg-[#991b1b] transition-all duration-300 ease-in-out w-12 flex items-center justify-center hover:w-[150px] group"
					>
						<svg
							className="w-6 h-6 group-hover:mr-2"
							fill="currentColor"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
						</svg>
						<span className="hidden group-hover:inline whitespace-nowrap">070-8057-6837</span>
					</a>

					<button
						onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
						className="p-3 rounded-full bg-[#991b1b] text-white shadow-lg hover:bg-[#991b1b] transition-all duration-300 ease-in-out w-12 flex items-center justify-center hover:w-[150px] group"
					>
						<svg
							className="w-6 h-6 group-hover:mr-2"
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M5 10l7-7m0 0l7 7m-7-7v18"
							/>
						</svg>
						<span className="hidden group-hover:inline whitespace-nowrap">맨 위로 이동</span>
					</button>
				</div>
			)}
			</>




		</>
  	);
};

export default FloattingButtons;